<template>
  <div
    class="container p-5"
    style="min-height: 100vh; max-height: 100vh; overflow-y: auto"
  >
    <h5 class="text-left">
      {{ t('Add a new event') }}
      <small>
        or track with
        <span class="text-primary cursor-pointer" @click="method = 'manual'"
          >Event API</span
        >
      </small>
    </h5>

    <template v-if="method === 'auto'">
      <div class="row mt-3">
        <div class="col-lg-12 col-xs-12">
          <div class="text-left form-group">
            <label v-translate for="inputName">Event Name</label>

            <input
              type="text"
              id="nickname-1"
              v-model="event_name"
              required="required"
              placeholder="e.g. Homepage CTA"
              class="form-control"
            />
            <small id="emailHelp" class="form-text text-muted" v-translate
              >Give this event a name.</small
            >
            <span v-if="errorName" class="text-danger small">{{
              errorName
            }}</span>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-12 col-xs-12">
          <div class="text-left form-group">
            <label v-translate for="inputName"
              >What CTA or Button Text to track?</label
            >
            <input
              type="text"
              id="nickname-1"
              v-model="event_text"
              placeholder="e.g. Add to cart"
              required="required"
              class="form-control"
            />
            <span v-if="errorText" class="text-danger small">{{
              errorText
            }}</span>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3">
        <div class="col-lg-12 col-xs-12">
          <div class="text-left form-group">
            <label v-translate for="inputName">Matching Rule</label>
            <input
              type="text"
              id="nickname-1"
              v-model="matchingrule"
              placeholder="e.g. Add to cart"
              required="required"
              class="form-control"
            />
          </div>
        </div>
      </div> -->

      <div class="row mt-3" v-if="suggestion.length">
        <div class="col-lg-12 col-xs-12">
          <div class="text-left form-group">
            <label v-translate for="inputName" class="mb-0"
              >Keyword Suggestion</label
            >
            <small id="emailHelp" class="form-text text-muted mb-1" v-translate
              >We found these CTA that have been clicked the most out of your
              website, click on them to add into tracking list.</small
            >

            <ul class="list-group">
              <li
                class="list-group-item cursor-pointer"
                @click="setEvent(item.event_text)"
                v-for="(item, key) in suggestion"
                :key="key"
              >
                <font-awesome-icon icon="mouse-pointer" class="mr-2 fa-sm" />
                {{ item.event_text }}
                <span class="float-right badge badge-light">{{
                  item.count
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex">
        <div>
          <label
            class="font-weight-bold form-check-label autostart-pageload-row"
            style="font-weight: 500"
            >{{ t("Enabling user identification") }}
            <span
              class="badge badge-highlight small cursor-pointer ml-2"
              v-if="
                $isFreePlan.includes($session.get('paid_plan')) ||
                $isLegacyFreePlan.includes($session.get('paid_plan')) ||
                $isBasicPlan.includes($session.get('paid_plan'))
              "
              @click="showUpgrade('pro')"
              >Pro plan
            </span>
          </label>
          <small class="form-text text-muted"
            >{{ t("Configure user with identify API. ") }}
            <a
              v-if="this.isHowuku"
              href="https://howuku.freshdesk.com/support/solutions/articles/150000072564-how-to-identify-user-with-api-"
              target="_blank"
            >
              <b class="text-primary"><u>Learn more</u></b>
            </a>
          </small>
        </div>
      </div>
    </template>

    <template v-if="method === 'manual'">
      <div class="row mt-3">
        <div class="col-lg-12 col-xs-12">
          <div class="text-left">
            <label v-translate for="inputName"
              >Track events with Javascript</label
            >
            <p
              class="font-weight-light text-primary"
              style="
                background-color: #e2f3ff;
                border: 1px solid #c7e4ff;
                color: rgb(253, 39, 0) !important;
                padding: 10px;
              "
            >
              &lt;script&gt;
              <br />&nbsp;&nbsp;&nbsp;&nbsp;howuku.track(
              <b>"EVENT_NAME_HERE"</b>); <br />&lt;/script&gt;
            </p>
            <small id="emailHelp" class="form-text text-muted"
              >Use the code above to start tracking on specific events on your
              website.</small
            >
          </div>
        </div>
      </div>
    </template>
    <div class="row mt-3" v-if="method === 'auto'">
      <div class="col-lg-12 col-xs-12">
        <button class="btn btn-first" @click="save()">
          {{ t('Save Event') }}
        </button>
      </div>
    </div>
    <div class="row mt-3" v-else>
      <div class="col-lg-12 col-xs-12">
        <button class="btn btn-light" @click="method = 'auto'">
          {{ t('Go back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: [],
  data: function () {
    return {
      isHowuku: false,
      event_name: '',
      event_text: '',
      method: 'auto',
      errorName: '',
      errorText: '',
      suggestion: [],
      matchingrule: '=',
    }
  },
  mounted() {
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')

    this.isHowuku = window.location.href.includes('howuku.com')
    this.init()
  },
  methods: {
    setEvent(eventText) {
      this.event_text = eventText
      this.event_name = 'Clicked on "' + eventText + '"'
    },
    init() {
      this.$http
        .post(process.env.API_ENDPOINT + '/events/suggest', {
          widget_id: this.$session.get('widget_id'),
        })
        .then((response) => {
          this.suggestion = response.data
        })
    },
    save() {
      this.errorName = ''
      this.errorText = ''
      if (this.event_name === '') {
        this.errorName = this.t('Please give this event a name.')
      }
      if (this.event_text === '') {
        this.errorText = this.t(
          'Please enter a CTA or button text for tracking.'
        )
      }

      if (this.event_name !== '' && this.event_text !== '') {
        this.$http
          .post(process.env.API_ENDPOINT + '/events/save', {
            widget_id: this.$session.get('widget_id'),
            event_name: this.event_name,
            event_text: this.event_text,
            matching_rule: this.matchingrule,
          })
          .then((response) => {
            if (howuku)
              howuku.track('Add new', {
                user_id: this.$session.get('user_id'),
                product: 'Event Profile',
              })
            this.$modal.hide(this.$parent.name)
          })
      } else {
        return
      }
    },
    random() {
      return Math.floor(Math.random() * 10000 + 1)
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EventForm.vue